import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Avatar, Tag, Button, Typography, Space, Card, Spin, Collapse, Divider, Input, message, Modal, } from "antd";
import { EyeOutlined, ArrowLeftOutlined, } from "@ant-design/icons";
import axios from "./axiosConfig";
import Swal from "sweetalert2";



const ListadoSCL90 = () => {
  const { Text } = Typography;
  const { TextArea } = Input;

  const location = useLocation();





  const dni = location.state?.dni;
  const nombres = location.state?.nombres;
  const apellido = location.state?.apellido;
  const etapa = location.state?.etapa;
  const niSigedi = location.state?.niSigedi;
  //const tieneObservacion = location.state?.tiene_observacion;
  const observacion = location.state?.observacion;

  const [observacionState, setObservacionState] = useState(observacion);
  const [observacionValue, setObservacionValue] = useState("");
  const [tiempoEmpleado, setTiempoEmpleado] = useState("");

  //console.log("El primer valor que viene de observacion Value es:", observacionValue);



  //console.log("observacion", observacion);

  const datos = {
    dni,
    etapa,
  };
  // =====================================================
  // STATES
  // =====================================================

  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // =====================================================
  // CARGA INICIAL
  // =====================================================

  useEffect(() => {
    traerResultados();
  }, []);


  //Vuelve al listado general

  const vuelveAnterior = () => {
    navigate("/scl-90-listados");
  };





  // =====================================================
  // TRAER RESULTADOS
  // =====================================================

  const traerResultados = async () => {

    try {

      const response = await axios.post(
        "https://wwwp.isepsantafe.net.ar/psicologia/scl90_resultados_personal",
        datos
      );

      //console.log("Response:", response.data);
      // El endpoint devuelve un objeto, por eso lo envolvemos en []
      setResultados([response.data]);
      //console.log("Obser:", response.data.observacion.observacion);
      setObservacionValue(
        response.data.observacion?.observacion || ""
      )

      if (response.data) {
        const responseTiempo = await axios.post(
          "https://wwwp.isepsantafe.net.ar/psicologia/scl90/tiempo",
          datos
        );

//         console.log("Tiempo:", responseTiempo.data.duracion);
        setTiempoEmpleado(responseTiempo.data.duracion);
      }

    } catch (error) {

      //console.error(error);

    } finally {

      setLoading(false);

    }
  };

  // =====================================================
  // Mapea valores numéricos
  // =====================================================

  const mapa = {
    0: "Nada",
    1: "Muy poco",
    2: "Poco",
    3: "Bastante",
    4: "Mucho"
  };

  // =====================================================
  // COLOR GENERAL SEGÚN CANTIDAD DE ESCALAS ALTERADAS
  // =====================================================

  const obtenerColor = (escalas) => {

    const tieneLimite = escalas.some(
      (r) => r.supera_limite === "SI"
    );

    const tieneIntermedio = escalas.some(
      (r) => r.supera_intermedio === "SI"
    );

    if (tieneLimite) return "#cf1322";

    if (tieneIntermedio) return "#fa8c16";

    return "#52c41a";
  };




  // -----------------Manda Observacion------------------------+


  const enviarObservacion = async () => {

    if (
      !observacionValue ||
      observacionValue.trim().length < 1
    ) {

      Modal.warning({
        title: "Atención",
        content: "La observación no debe estar vacía !",
      });

      return;
    }

    const datosObservacion = {
      dni,
      etapa,
      usuario_observa: niSigedi,
      observacion: observacionValue
    };

    //console.log("Los datos de la observacion a enviar son:",datosObservacion.observacion);

    try {

      const response = await axios.post(
        "https://wwwp.isepsantafe.net.ar/psicologia/guardar-observacion-scl90",
        datosObservacion
      );

      //console.log("La data es:", response.data);

      if (response.data.ok === true) {

        setObservacionState(true);

        setObservacionValue(
          response.data.observacion
        );

        Modal.success({
          title: "Observación guardada",
          content: response.data.mensaje,
        });

      } else {

        Modal.warning({
          title: "Atención",
          content: response.data.mensaje,
        });
      }

    } catch (error) {

      console.error(error);

      Modal.error({
        title: "Error",
        content: "Error al guardar la observación",
      });
    }
  };

  const modificarObservacion = async () => {

    //console.log("Observacion Value es:",observacionValue);

    //console.log("Observacion es:",observacion);

    if (
      !observacionValue ||
      observacionValue.trim().length < 1
    ) {

      Modal.warning({
        title: "Atención",
        content: "La observación no debe estar vacía",
      });

      return;
    }

    Modal.confirm({

      title: "Confirmar modificación",

      content:
        "¿Seguro que desea modificar la observación?",

      okText: "Sí, modificar",

      cancelText: "Cancelar",

      onOk: async () => {

        const datosObservacion = {
          dni,
          etapa,
          usuario_observa: niSigedi,
          observacion: observacionValue
        };

        //console.log(datosObservacion);

        try {

          const response = await axios.post(
            "https://wwwp.isepsantafe.net.ar/psicologia/modificar-observacion-scl90",
            datosObservacion
          );

          //console.log(response.data);

          if (response.data.ok === true) {

            setObservacionValue(
              response.data.observacion ||
              observacionValue
            );

            Modal.success({
              title: "Observación modificada",
              content: response.data.mensaje,
            });

          } else {

            Modal.warning({
              title: "Atención",
              content: response.data.mensaje,
            });
          }

        } catch (error) {

          console.error(error);

          Modal.error({
            title: "Error",
            content:
              "Ocurrió un error al modificar la observación",
          });
        }
      }
    });
  };


  const descargarPDF = async () => {

    try {

      const response = await axios.post(
        "https://wwwp.isepsantafe.net.ar/psicologia/pdf_respuestas_scl90",
        {
          dni,
          etapa
        },
        {
          responseType: "blob"
        }
      );

      const blob = new Blob(
        [response.data],
        {
          type: "application/pdf"
        }
      );

      const url = window.URL.createObjectURL(blob);

      // =====================================================
      // NUEVA VENTANA
      // =====================================================
      const nuevaVentana = window.open("", "_blank");

      nuevaVentana.document.write(`
      <html>
        <head>
          <title>SCL90_${dni}</title>
          <style>
            html, body {
              margin: 0;
              height: 100%;
            }

            iframe {
              width: 100%;
              height: 100%;
              border: none;
            }
          </style>
        </head>

        <body>
          <iframe src="${url}"></iframe>
        </body>
      </html>
    `);

      nuevaVentana.document.close();

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo abrir el PDF"
      });

    }

  };






  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: 40,
        }}
      >
        <Spin />
      </div>
    );
  }

  // =====================================================
  // RENDER
  // =====================================================

  return (

    <div
      style={{
        padding: 18,
        background: "#f5f7fa",
        minHeight: "100vh",
      }}
    >

      {/* =====================================================
          LISTADO
      ===================================================== */}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >

        {
          resultados.map((persona) => {

            // Escalas reales
            const escalas = persona.resultados.filter(
              (r) =>
                !["IGS", "IMSP", "TSP"].includes(r.clave)
            );

            // Escalas alteradas o intermedias
            const alterados = escalas.filter(
              (r) =>
                r.supera_limite === "SI" ||
                r.supera_intermedio === "SI"
            );

            // Indicadores globales
            const igs = persona.resultados.find(
              (r) => r.clave === "IGS"
            );

            const tsp = persona.resultados.find(
              (r) => r.clave === "TSP"
            );

            const imsp = persona.resultados.find(
              (r) => r.clave === "IMSP"
            );

            return (

              <Card
                key={persona.dni}
                variant="borderless"
                style={{
                  borderRadius: 14,
                }}
                styles={{
                  body: {
                    padding: 18,
                  },
                }}
              >



                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 20,
                    flexWrap: "wrap",
                  }}
                >

                  {/* DATOS PERSONA */}

                  <div
                    style={{
                      display: "flex",
                      gap: 14,
                    }}
                  >

                    <Avatar
                      size={54}
                      style={{
                        background: obtenerColor(escalas),
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      {alterados.length}
                    </Avatar>

                    <div>

                      <div
                        style={{
                          fontSize: 18,
                          fontWeight: 700,
                          marginBottom: 2,
                        }}
                      >
                        {nombres + " " + apellido || "Sin nombre"}
                      </div>

                      <Text type="secondary">
                        DNI: {persona.dni}
                      </Text>




                      <div
                        style={{
                          marginTop: 6,
                        }}
                      >
                        <Tag color="blue">
                          {persona.etapa}
                        </Tag>
                      </div>

                    </div>

                  </div>

                  <div>

                    <Button
                      //type="primary"
                      // danger
                      onClick={descargarPDF}
                    >
                      Ver intento
                    </Button>

                  </div>

                  {/* INDICADORES */}

                  <Space size={20} wrap>

                    <div>
                      <Text type="secondary">Tiempo empleado</Text>

                      <div
                        style={{
                          fontWeight: 400,
                          fontSize: 18,
                          textAlign: "center",
                        }}
                      >
                        {tiempoEmpleado
                          ? `${tiempoEmpleado.minutos} min ${tiempoEmpleado.segundos} seg`
                          : "-"}
                      </div>
                    </div>

                    <div>
                      <Text type="secondary">IGS</Text>

                      <div
                        style={{
                          marginTop: 4,
                          textAlign: "center",
                        }}
                      >
                        <Tag
                          color={
                            igs?.supera_limite === "SI"
                              ? "error"
                              : igs?.supera_intermedio === "SI"
                                ? "warning"
                                : "success"
                          }
                          style={{
                            fontWeight: 700,
                            fontSize: 15,
                            paddingInline: 10,
                          }}
                        >
                          {igs?.valor_t || "-"}
                        </Tag>
                      </div>
                    </div>

                    <div>
                      <Text type="secondary">TSP</Text>

                      <div
                        style={{
                          marginTop: 4,
                          textAlign: "center",
                        }}
                      >
                        <Tag
                          color={
                            tsp?.supera_limite === "SI"
                              ? "error"
                              : tsp?.supera_intermedio === "SI"
                                ? "warning"
                                : "success"
                          }
                          style={{
                            fontWeight: 700,
                            fontSize: 15,
                            paddingInline: 10,
                          }}
                        >
                          {tsp?.valor_t || "-"}
                        </Tag>
                      </div>
                    </div>

                    <div>
                      <Text type="secondary">IMSP</Text>

                      <div
                        style={{
                          marginTop: 4,
                          textAlign: "center",
                        }}
                      >
                        <Tag
                          color={
                            imsp?.supera_limite === "SI"
                              ? "error"
                              : imsp?.supera_intermedio === "SI"
                                ? "warning"
                                : "success"
                          }
                          style={{
                            fontWeight: 700,
                            fontSize: 15,
                            paddingInline: 10,
                          }}
                        >
                          {imsp?.valor_t || "-"}
                        </Tag>
                      </div>
                    </div>

                    <Button
                      type="primary"
                      icon={<ArrowLeftOutlined />}
                      onClick={vuelveAnterior}
                    >
                      Volver
                    </Button>

                  </Space>

                </div>

                <Divider />

                {/* =====================================================
                    TAGS DE ESCALAS ALTERADAS
                ===================================================== */}

                <div
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 6,
                  }}
                >

                  {
                    alterados.length === 0 ? (

                      <Tag color="success">
                        Perfil dentro de parámetros
                      </Tag>

                    ) : (

                      alterados.map((item, idx) => {

                        let colorTag = "success";

                        if (item.supera_limite === "SI") {

                          colorTag = "error";

                        } else if (item.supera_intermedio === "SI") {

                          colorTag = "warning";
                        }

                        return (

                          <Tag
                            key={idx}
                            color={colorTag}
                          >
                            {item.clave} · T {item.valor_t}
                          </Tag>

                        );

                      })
                    )
                  }

                </div>

                {/* =====================================================
                    DETALLE DE ESCALAS
                ===================================================== */}

                <Collapse
                  ghost
                  items={escalas.map((escala, idx) => ({

                    key: idx,

                    // =====================================================
                    // HEADER DE CADA ESCALA
                    // =====================================================

                    label: (

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingRight: 10,
                          gap: 10,
                          flexWrap: "wrap",
                        }}
                      >

                        <Space wrap>

                          <Text strong>
                            {escala.nombre}
                          </Text>

                          <Tag
                            color={
                              escala.supera_limite === "SI"
                                ? "error"
                                : escala.supera_intermedio === "SI"
                                  ? "warning"
                                  : "success"
                            }
                          >
                            {escala.clave}
                          </Tag>

                        </Space>

                        <Space size={12} wrap>

                          <Text>
                            Puntaje: <b>{escala.valor}</b>
                          </Text>

                          <Text>
                            T: <b>{escala.valor_t ? escala.valor_t : "-"}</b>
                          </Text>

                        </Space>

                      </div>

                    ),

                    // =====================================================
                    // CONTENIDO DE LA ESCALA
                    // =====================================================

                    children: (

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                        }}
                      >

                        {
                          escala.items.map((item, i) => (

                            <div
                              key={i}
                              style={{
                                background: "#fafafa",
                                border: "1px solid #f0f0f0",
                                borderRadius: 10,
                                padding: 12,
                              }}
                            >

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "flex-start",
                                  gap: 12,
                                }}
                              >

                                {/* TEXTO */}

                                <div>

                                  <div
                                    style={{
                                      fontWeight: 600,
                                      marginBottom: 4,
                                    }}
                                  >
                                    #{item.pregunta}
                                  </div>

                                  <Text>
                                    {item.texto}
                                  </Text>

                                </div>

                                {/* RESPUESTA */}

                                <Tag
                                  /*color={
                                    item.respuesta >= 4
                                      ? "error"
                                      : item.respuesta >= 2
                                        ? "warning"
                                        : "default"
                                  }*/
                                  style={{
                                    minWidth: 70,
                                    textAlign: "center",
                                    fontWeight: 700,
                                    fontSize: 14,
                                  }}
                                >
                                  {mapa[item.respuesta]}
                                </Tag>

                              </div>



                            </div>


                          ))
                        }

                      </div>

                    ),

                  }))}
                />



              </Card>



            );
          })
        }

      </div>


      <div
        style={{
          marginTop: 20,
          background: "#fff",
          padding: 16,
          borderRadius: 10
        }}
      >

        {
          observacionState ? (
            <div
              style={{
                fontWeight: 600,
                marginBottom: 8
              }}
            >
              ¡El usuario ya tiene observación!
            </div>
          ) : (
            <div
              style={{
                fontWeight: 600,
                marginBottom: 8
              }}
            >
              Observaciones:
            </div>
          )
        }


        <TextArea
          rows={5}
          placeholder="Escriba una observación..."
          defaultValue={observacionValue}
          onChange={(e) => {
            setObservacionValue(e.target.value);
          }}
        />

        {!observacionState && (
          <Button
            type="primary"
            style={{ marginTop: 12 }}
            onClick={enviarObservacion}
          >
            Enviar observación
          </Button>
        )}
        {observacionState && (
          <Button
            type="primary"
            style={{ marginTop: 12 }}
            onClick={modificarObservacion}
          >
            Modificar
          </Button>
        )}
      </div>

    </div>
  );
};

export default ListadoSCL90;